import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEmbedCode } from 'web-interactives-dashboard-ui/actions/EmbedCodeActions';
import { getEmbedCode, getFetchEmbedRequestFailed } from 'web-interactives-dashboard-ui/selectors/embedCode';
import { MODAL_TYPES } from 'web-interactives-dashboard-ui/constants/ModalConstants';
import withModalProps from 'web-interactives-dashboard-ui/hoc/withModalProps';
import EmbeddingInstructionsModal from 'web-interactives-components/embed/EmbeddingInstructionsModal';
import usageTracker from 'web-interactives-dashboard-ui/utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const EmbeddingInfoModal = ({
  interactiveId,
  onClose
}) => {
  const dispatch = useDispatch();
  const embedCode = useSelector(getEmbedCode);
  const requestFailed = useSelector(getFetchEmbedRequestFailed);
  useEffect(() => {
    dispatch(fetchEmbedCode(interactiveId));
  }, [interactiveId, dispatch]);
  function handleCopy() {
    usageTracker.trackDashboardInteraction({
      action: 'Clicked Embed Modal Copy',
      event: 'embed-modal-copy-click',
      source: 'Embed Modal'
    }, true);
  }
  return /*#__PURE__*/_jsx(EmbeddingInstructionsModal, {
    embedCode: embedCode,
    embedCodeFetchError: requestFailed,
    onClose: onClose,
    onCopyClick: handleCopy
  });
};
export default withModalProps(EmbeddingInfoModal, MODAL_TYPES.EMBEDDING_INFO);